import { Platform, StyleSheet } from "react-native";
import { colors, fonts } from "./theme";

const commonStyles = StyleSheet.create({
  // Extra breathing room between screen content and the system navigation bar
  // / home indicator. SafeAreaView edges are "additive", so a screen using this
  // ends up with insets.bottom + screenBottomGap. Tune here, not per screen.
  screenBottomGap: {
    paddingBottom: 5,
  },

  //Container section
  container: {
    flex: 1,
    paddingHorizontal: 10,
    paddingVertical: 10,
    backgroundColor: colors.white,
  },

  subHeaderContainer: {
    display: "flex",
    flexDirection: "row",
    gap: 7,
    alignItems: "center",
    marginVertical: 10,
  },
  detailsLabelContainer: {
    flexDirection: "row",
    gap: 13,
  },

  detailsGroupContainer: {
    flexDirection: "column",
  },
  cardItemblock: {
    flexDirection: "row",
    justifyContent: "space-between",
  },

  cardItem: {
    flexDirection: "column",
    justifyContent: "space-between",
  },

  subContainer: {
    backgroundColor: "white",
    borderRadius: 19,
    shadowColor: "gray",
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 3,
  },

  headerContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 12,
    backgroundColor: colors.white,
  },
  scrollContainer: {
    padding: 16,
  },

  //Flex section
  flexEnd: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-end",
  },

  flexSpaceBetween: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },

  flex1: {
    flex: 1,
    backgroundColor: colors.white,
  },

  flexColumnSB: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-between",
  },

  flexCenter: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },

  //Header section
  header: {
    fontSize: 22,
    //fontWeight: "800",
    fontFamily: fonts.bold,
    // marginLeft: 0
  },

  subHeader: {
    fontSize: 20,
    //fontWeight: "600",
    fontFamily: fonts.medium,
    marginTop: Platform.OS === "android" ? 5 : 0,
  },

  summaryHeader: {
    fontSize: 18,
    //fontWeight: "bold",
    marginBottom: 8,
    fontFamily: fonts.bold,
  },

  detailsHeader: {
    fontSize: 18,
    //fontWeight: "bold",
    marginTop: 15,
    fontFamily: fonts.bold,
    marginLeft: 7,
  },

  detailsSubHeader: {
    fontSize: 16,
    //fontWeight: "bold",
    marginBottom: 4,
    fontFamily: fonts.medium,
  },

  //Title inside details
  subTitle: {
    fontSize: 16,
    color: colors.textGray,
    marginTop: 10,
    fontFamily: fonts.regular,
  },

  summaryItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 10,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: colors.borderLighter,
  },

  detailsLabel: {
    fontSize: 12,
    color: colors.textGrayDark,
    //marginRight: 2,
    fontFamily: fonts.regular,
  },

  //Value section
  subValue: {
    fontSize: 16,
    //fontWeight: "bold",
    color: colors.primaryAlt,
    marginTop: 10,
    textAlign: "right",
    fontFamily: fonts.medium,
  },

   subtitle: {
    fontSize: 16,
    //fontWeight: "bold",
    color: colors.primaryAlt,
    // marginTop: 10,
    fontFamily: fonts.regular,
  },

   subText: {
    fontSize: 12,
    //color: '#000000',
    marginTop: 4,
    fontFamily: fonts.regular,
  },

  summaryAmount: {
    // fontWeight: "bold",
    color: colors.primaryAlt,
    fontFamily: fonts.bold,
  },

  detailsValue: {
    fontSize: 12,
    color: colors.primaryAlt,
    //fontWeight: "bold",
    fontFamily: fonts.medium,
  },

  subDetails: {
    width: "100%",
    flexDirection: "row",
    display: "flex",
    justifyContent: "space-between",
    borderBottomWidth: 1,
    borderBottomColor: colors.borderLight,
    padding: 10,
  },

  emptyData: {
    textAlign: "center",
    marginVertical: 10,
    fontSize: 16,
    color: colors.black,
    fontFamily: fonts.regular,
  },

  //Fonts
  commonFont: {
    fontFamily: fonts.regular,
  },

  boldText: {
    fontWeight: "bold",
  },

  // COLORS
  primaryColor: {
    color: colors.primary,
  },
  primaryBgColor: {
    backgroundColor: colors.primary,
  },

  //Screen size
  fH: {
    height: "100%",
  },
  fw: {
    width: "100%",
  },

  // Margin and padding sections
  mh10: {
    marginHorizontal: 10,
  },
  mv10: {
    marginVertical: 10,
  },
  mb5: {
    marginBottom: 5,
  },
  mb10: {
    marginBottom: 10,
  },

  mr8: {
    marginRight: 5,
  },

  mb15: {
    marginBottom: 15,
  },
  mb20: {
    marginBottom: 20,
  },
  mb25: {
    marginBottom: 25,
  },
  mb30: {
    marginBottom: 30,
  },

  mr10: {
    marginRight: 10,
  },
  mr15: {
    marginRight: 15,
  },
  mr20: {
    marginRight: 20,
  },

  ml7: {
    marginLeft: 7,
  },

  pb16: {
    paddingBottom: 16,
  },
  pb25: {
    paddingBottom: 25,
  },
  pl15: {
    paddingLeft: 15,
  },
  pl20: {
    paddingLeft: 20,
  },
  pl25: {
    paddingLeft: 25,
  },
  p15: {
    paddingRight: 15,
    paddingTop: 15,
    paddingBottom: 15,
  },

  fWB: {
    fontWeight: "bold",
  },
  pt0: {
    paddingTop: 0,
  },
  pt5: {
    paddingTop: 5,
  },
  pt10: {
    paddingTop: 10,
  },
  pt15: {
    paddingTop: 15,
  },
  pt20: {
    paddingTop: 20,
  },

  p8: {
    padding: 8,
  },

  p14: {
    padding: 14,
  },
  p16: {
    padding: 16,
  },

  mt5: {
    marginTop: 5,
  },

  ml12: {
    marginLeft: 12,
  },

  ml10: {
    marginLeft: 10,
  },
  mt10: {
    marginTop: 10,
  },
  mt15: {
    marginTop: 15,
  },
  mt20: {
    marginTop: 20,
  },
  mt25: {
    marginTop: 25,
  },
  mt30: {
    marginTop: 30,
  },
  mt35: {
    marginTop: 35,
  },
  mt40: {
    marginTop: 40,
  },
  mt45: {
    marginTop: 45,
  },
  mt50: {
    marginTop: 50,
  },
  mt55: {
    marginTop: 55,
  },
  mt75: {
    marginTop: 75,
  },

  mlar2: {
    marginLeft: 2,
    marginRight: 2,
  },

  mlar5: {
    marginLeft: 3,
    marginRight: 3,
  },

  divider: {
    height: 1,
    backgroundColor: colors.borderLight,
    marginVertical: 30,
  },

  link: {
    fontSize: 16,
    //fontWeight: "bold",
    color: colors.primaryAlt,
    textDecorationLine: "underline",
    marginTop: 10,
    fontFamily: fonts.medium,
  },
  button: {
    backgroundColor: colors.buttonBg,
    borderRadius: 10,
    padding: 15,
    alignItems: "center",
    marginTop: 10,
  },
  buttonText: {
    color: colors.white,
    fontSize: 16,
    //fontWeight: "600",
    fontFamily: fonts.regular,
  },
  columnContainer: {
    width: "100%",
    flexDirection: "column",
    display: "flex",
    borderBottomWidth: 1,
    borderBottomColor: colors.borderLight,

    padding: 10,
  },
  sectionLabel: {
    fontSize: 16,
    color: colors.textGray,
    marginTop: 0,
    fontFamily: fonts.regular,
  },
  valueText: {
    fontSize: 16,
    //fontWeight: "bold",
    color: colors.primaryAlt,
    textAlign: "right",
    fontFamily: fonts.medium,
  },
});

export default commonStyles;
